<div class="achd-top">
  <h2>Chat history</h2>
  <button type="button" class="achd-close" (click)="close.emit()" aria-label="Close dialog">
    <span class="material-icons">close</span>
  </button>
</div>
<p class="achd-muted">Resume earlier conversations with {{ agentName || 'your agent' }}.</p>

<div *ngIf="loading" class="achd-loading"><div class="achd-spinner"></div><span>Loading chats...</span></div>

<label class="achd-search" *ngIf="!loading && chats?.length">
  <span class="material-icons">search</span>
  <input type="search" placeholder="Search chats" aria-label="Search chats by title"
    [value]="query" (input)="query = $any($event.target).value" />
</label>

<div class="achd-list" *ngIf="!loading && filteredChats.length">
  <div *ngFor="let chat of filteredChats" class="achd-row" [class.achd-row--active]="chat.id === currentChatId" (click)="openChat.emit(chat)">
    <span class="material-icons achd-icon">chat_bubble_outline</span>
    <div class="achd-text">
      <span class="achd-title" [title]="chat.title">{{ chat.title }}</span>
      <small>{{ timeAgo(chat.timestamp) }}</small>
    </div>
    <button type="button" class="achd-delete" aria-label="Delete chat" (click)="deleteChat.emit({ chat: chat, event: $event })">
      <span class="material-icons">delete</span>
    </button>
  </div>
</div>

<p *ngIf="!loading && !chats?.length" class="achd-muted achd-empty">No chat history yet</p>
<p *ngIf="!loading && chats?.length && !filteredChats.length" class="achd-muted achd-empty">No chats match "{{ query.trim() }}"</p>

<div class="achd-actions">
  <button type="button" class="achd-btn" (click)="newChat.emit()">＋ New chat</button>
  <button type="button" class="achd-btn achd-btn--danger" *ngIf="chats?.length" (click)="deleteAll.emit($event)">Delete all chats</button>
</div>
